import React, { useEffect } from "react";
import TicketStatusSub from "../../components/TicketStatusSub";
import { selectUser } from "../../store/slice/user";
import { useSelector } from "react-redux";
import mixpanel from "mixpanel-browser";

const OrderSuccessSub = () => {
  const user = useSelector(selectUser);
  useEffect(() => {
    mixpanel?.track("order-success", {
      email: user?.email,
      name: user?.name || "anonymous",
    });
  }, []);
  return <TicketStatusSub success={true} />;
};

export default OrderSuccessSub;
